import { useState, useEffect } from 'react';
import errorReporter from '@app/errorReporter';
import type { LockboxAccessLogType } from '@/app-package';

import API from 'api';

type RequestStatusType = 'pending' | 'success' | 'error';

export default function useLockboxAccessLogs(
  lockboxType: 'masterlock' | 'sentrilock',
  deviceId: string,
  page: number,
  date?: Date,
) {
  const [requestStatus, setRequestStatus] =
    useState<RequestStatusType>('pending');
  const [accessLogs, setAccessLogs] = useState<LockboxAccessLogType[]>([]);
  const [accessLogsCount, setAccessLogsCount] = useState(0);

  useEffect(() => {
    (async () => {
      setRequestStatus('pending');
      try {
        const result = await API.GET.getLockboxAccessLogs(
          lockboxType,
          deviceId,
          page - 1,
          date,
        );
        setAccessLogs(result.accessLogs);
        setAccessLogsCount(result.accessLogsCount);
        setRequestStatus('success');
      } catch (err) {
        errorReporter.error(err);
        setRequestStatus('error');
      }
    })();
  }, [lockboxType, deviceId, page]);

  return { requestStatus, accessLogs, accessLogsCount };
}
